import { Action } from '@ngrx/store';

export const SET_PAYMENT_METHOD = '[PAYMENT METHODS] set payment methods';

export class SetPaymentMethods implements Action {
  readonly type = SET_PAYMENT_METHOD;
  constructor(public payload: any) {}
}

export type PaymentMethodsActions = SetPaymentMethods;
